module.exports = __webpack_public_path__ + "media/alarm.75a04130.mp3";